import apiClient from "../../api/apiClient";

/**
 * Product Service
 * Handles all API calls related to product management
 */

// ================= GET ALL PRODUCTS =================
export const getProductsApi = async (
  page: number,
  pageSize: number,
  tenantId: string,
  search: string
) => {
  const res = await apiClient.get("/products", {
    params: {
      PageNumber: page,
      PageSize: pageSize,
      Search: search,
      tenantId,
    },
  });

  return res.data;
};

// ================= GET PRODUCT BY ID =================
export const getProductByIdApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.get(
    `/products/${id}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// ================= CREATE PRODUCT =================
export const createProductApi = async (
  data: FormData,
  tenantId: string
) => {
  const res = await apiClient.post(
    "/products",
    data,
    {
      params: {
        tenantId,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};

// ================= UPDATE PRODUCT =================
export const updateProductApi = async (
  data: FormData,
  tenantId: string
) => {
  const res = await apiClient.put(
    "/products",
    data,
    {
      params: {
        tenantId,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};

// ================= DELETE PRODUCT =================
export const deleteProductApi = async (
  id: string,
  tenantId: string
) => {
  const res = await apiClient.delete(
    `/products/${id}`,
    {
      params: {
        tenantId,
      },
    }
  );

  return res.data;
};

// Export as a service object
export const productService = {
  getProductsApi,
  getProductByIdApi,
  createProductApi,
  updateProductApi,
  deleteProductApi,
};